import { render, staticRenderFns } from "./CityChannelComparison.vue?vue&type=template&id=3182f3e9&scoped=true"
import script from "./CityChannelComparison.vue?vue&type=script&lang=js"
export * from "./CityChannelComparison.vue?vue&type=script&lang=js"
import style0 from "./CityChannelComparison.vue?vue&type=style&index=0&id=3182f3e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3182f3e9",
  null
  
)

export default component.exports